import {
	getEffectiveStatus,
	type RenderableContentArtifact,
} from '@/hooks/useContentArtifacts';

import type { Action } from '../../../../bridge/types/action.ts';
import {
	isDigitalAd,
	isEmail,
	isPost,
} from '../../../../bridge/types/artifact.ts';
import type { Process } from '../../../../bridge/types/process.ts';

import { DigitalAdContentDetail } from './DigitalAdContentDetail';
import { EmailContentDetail } from './EmailContentDetail';
import { PostContentDetail } from './PostContentDetail';

interface ContentDetailProps {
	artifact: RenderableContentArtifact;
	processById: Map<string, Process>;
	emailActionByRef: Map<string, Action>;
	refresh?: () => Promise<void>;
}

export const ContentDetail = ({
	artifact,
	processById,
	emailActionByRef,
	refresh,
}: ContentDetailProps) => {
	if (isPost(artifact)) {
		return (
			<PostContentDetail
				post={artifact}
				processById={processById}
				refresh={refresh}
			/>
		);
	}
	if (isDigitalAd(artifact)) {
		return <DigitalAdContentDetail artifact={artifact} refresh={refresh} />;
	}
	if (isEmail(artifact)) {
		const action = emailActionByRef.get(artifact.id);
		const effectiveStatus = getEffectiveStatus(artifact, processById);
		return (
			<EmailContentDetail
				artifact={artifact}
				action={action}
				effectiveStatus={effectiveStatus}
				refresh={refresh}
			/>
		);
	}
	return null;
};
